import React from "react";

export default function AboutModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#222', color: '#fff', borderRadius: 12, padding: 28, width: 420, maxWidth: '96vw', boxShadow: '0 6px 48px #000b'
      }}>
        <h2 style={{marginTop: 0}}>About Point Atlas</h2>
        <p>
          <strong>Point Atlas exists because we believe maps should be a public, collaborative good.</strong> Anyone can upload and maintain their own maps. Only map owners can add or edit points of interest directly, protecting their work from trolls or spam. However, all users can suggest new POIs or improvements to map owners, encouraging collaboration without risking quality.
        </p>
        <p>
          <strong>We also believe in stewardship and openness.</strong> If a map is abandoned (not updated for 6 months), the community can branch it and continue the work—so valuable data is never lost. Your contributions always belong to you, and the community—not a corporation.
        </p>
        <p>
          <strong>Map creators get 100% of any tips people give them (if any)!</strong> Point Atlas takes no cut. We want to reward and empower the people who build and share great content.
        </p>
        <button
          onClick={onClose}
          style={{ marginTop: 16, background: "#e24", color: "#fff", border: "none", borderRadius: 6, padding: "8px 20px", fontSize: 16, cursor: "pointer" }}
        >Close</button>
      </div>
    </div>
  );
}
